import { render, staticRenderFns } from "./MemberTier.vue?vue&type=template&id=42b229f3&scoped=true"
import script from "./MemberTier.vue?vue&type=script&lang=js"
export * from "./MemberTier.vue?vue&type=script&lang=js"
import style0 from "./MemberTier.vue?vue&type=style&index=0&id=42b229f3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42b229f3",
  null
  
)

export default component.exports